import { Button, ButtonVariant } from "@repo/ui/Buttons/button";
import { Size } from "@repo/ui/helpers/helpers";
import { IconFlagCheck, IconPencil } from "@tabler/icons-react";
import type { FC } from "react";

export interface CoachingManagerActionsProps {
  hasCurrentNote: boolean;
  hasNextGoal: boolean;
  onAddNote: () => void;
  onSetNextGoal: () => void;
}

export const CoachingManagerActions: FC<CoachingManagerActionsProps> = (
  props,
) => {
  const { hasCurrentNote, hasNextGoal, onAddNote, onSetNextGoal } = props;

  return (
    <div
      className="flex flex-wrap items-center gap-2"
      role="group"
      aria-label="Coaching goal actions"
    >
      <Button
        variant={ButtonVariant.Secondary}
        size={Size.SMALL}
        icon={<IconPencil className="size-4" />}
        onClick={onAddNote}
      >
        {hasCurrentNote ? "Edit this week's note" : "Add a note"}
      </Button>
      <Button
        variant={ButtonVariant.Secondary}
        size={Size.SMALL}
        icon={<IconFlagCheck className="size-4" />}
        onClick={onSetNextGoal}
      >
        {hasNextGoal ? "Edit next week's goal" : "Choose next week's goal"}
      </Button>
    </div>
  );
};
